import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const LoaderContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
`

export const ButtonContainer = styled.div`
  width: 100%;

  display: inline-block;

  ${mediaQueries.tablet} {
    width: fit-content;
  }
`

export const RemoveDomainTextContainer = styled.div`
  color: ${Colors.GS600};
`
